import { BaseTypeLiterals } from "../../application/domain/base/base-type";

export const matchTotalPage = <R>(
  totalPage: number,
  matcher: BaseTypeLiterals<"NO_RESOURCE" | "RESOURCE_EXISTS", R>,
): R => {
  if (totalPage === 0) {
    return matcher["NO_RESOURCE"];
  }
  return matcher["RESOURCE_EXISTS"];
};
